import React, { useState } from 'react'

interface RetractedDeniedFormProps {
  onSubmit?: (data: { status: string; comments: string }) => void
  onCancel?: () => void
}

const RetractedDeniedForm: React.FC<RetractedDeniedFormProps> = ({
  onSubmit,
  onCancel,
}) => {
  const [selectedStatus, setSelectedStatus] = useState('approved')
  const [approverComments, setApproverComments] = useState('')

  const handleSubmit = () => {
    if (onSubmit) {
      onSubmit({
        status: selectedStatus,
        comments: approverComments,
      })
    }
  }

  return (
    <div className="contents">
      <div>
        <div className="px-6! py-6!">
          <h4 className="text-[#0D1C3D] text-sm font-light leading-[1.428] mb-6">
             Select a Request Status
          </h4>

          {/* Status Radio Buttons - Only Approve enabled */}
          <div className="space-y-4 mb-8 pb-6!">
            <div className="flex items-center gap-3 mb-1!">
              <input
                type="radio"
                id="approved"
                name="status"
                value="approved"
                checked={selectedStatus === 'approved'}
                onChange={(e) => setSelectedStatus(e.target.value)}
                className="w-4 h-4"
              />
              <label
                htmlFor="approved"
                className="text-[#0D1C3D] text-base font-light leading-6 tracking-[0.16px] cursor-pointer"
              >
                Approve
              </label>
            </div>

            {/* All other options disabled */}
            <div className="flex items-center gap-3 mb-1!">
              <input
                type="radio"
                id="denied"
                name="status"
                value="denied"
                disabled
                className="w-4 h-4"
              />
              <label
                htmlFor="denied"
                className="text-[#A0A5B6] text-base font-light leading-6 tracking-[0.16px]"
              >
                Denied
              </label>
            </div>

            <div className="flex items-center gap-3 mb-1!">
              <input
                type="radio"
                id="hold"
                name="status"
                value="hold"
                disabled
                className="w-4 h-4"
              />
              <label
                htmlFor="hold"
                className="text-[#A0A5B6] text-base font-light leading-6 tracking-[0.16px]"
              >
                Hold
              </label>
            </div>

            <div className="flex items-center gap-3 mb-1!">
              <input
                type="radio"
                id="returned"
                name="status"
                value="returned"
                disabled
                className="w-4 h-4"
              />
              <label
                htmlFor="returned"
                className="text-[#A0A5B6] text-base font-light leading-6 tracking-[0.16px]"
              >
                Returned
              </label>
            </div>
          </div>

          {/* Approver Comments */}
          <div className="mb-6 pt-6 pb-6!">
            <label htmlFor="comments" className="block p3 -medium mb-1">
              Approver Comments
            </label>
            <textarea
              id="comments"
              className="w-full border rounded p-2 min-h-20 disabled:bg-gray-100 disabled:cursor-not-allowed"
              maxLength={1000}
              value={approverComments}
              onChange={(e) => setApproverComments(e.target.value)}
            />
            <div className="text-left text-xs text-gray-500 mt-1">
              {1000 - approverComments.length} of 1000 characters left
            </div>
          </div>

          {/* Action Buttons */}
          <div className="flex gap-3 justify-start pt-6">
            <button className="button -secondary" onClick={onCancel}>
              Cancel
            </button>
            <button className="button -primary" onClick={handleSubmit}>
              Yes, override this denied retraction request
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default RetractedDeniedForm
